module.exports = __webpack_public_path__ + "img/en.67492636.png";